import React, { useCallback, useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import DroppableList from '../DraggingWrappers/DroppableList';
import styles from "../Merging.module.css";
import classes from './KeywordsMergingDisplay.module.css'
import PulsingDivWrapper from "../DraggingWrappers/PulsingDivWrapper";
import Button from "react-bootstrap/Button";
import {Forward} from "@material-ui/icons";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

const KeywordsMergingDisplay = forwardRef(({ patternSelected, fromPattern, toPattern }, ref) => {
    const [fromList, setFromList] = useState([]);
    const [toList, setToList] = useState([]);
    const [isDraggingFrom, setIsDraggingFrom] = useState(false)
    const [isDraggingTo, setIsDraggingTo] = useState(false)

    const existsInToList = useCallback((item) => {
        return (
            Array.isArray(toList) &&
            item && item.keywordObj &&
            toList.some(f => +item.keywordObj.keyword_id === +f.keywordObj.keyword_id)
        );
    }, [toList]);

    const existsInFromList = useCallback((item) => {
        return (
            Array.isArray(fromList) &&
            item && item.keywordObj &&
            fromList.some(f => +item.keywordObj.keyword_id === +f.keywordObj.keyword_id)
        );
    }, [fromList]);

    useEffect(() => {
        if (fromPattern && fromPattern.keywords) {
            const updatedFromList = fromPattern.keywords.map((keywords) => {
                const id = keywords.keyword_id + " pattern_id-" + fromPattern.pattern_id;
                const isGrayedOut = existsInToList({ keywordObj: keywords });

                return {
                    id,
                    keywordObj: keywords,
                    content: (

                        <OverlayTrigger
                            key={"overlay" + keywords.keyword_id}
                            trigger={['hover', 'focus']}
                            rootClose
                            //rootCloseEvent="hover-off"
                            placement='bottom'
                            overlay={<Popover id='pattern-keyword-description'>
                                <Popover.Title as="h3">{keywords.keyword}: Description</Popover.Title>
                                <Popover.Content className="keyword-description">
                                    {keywords.keyword_description}
                                </Popover.Content>
                            </Popover>}
                        >
                            <div
                                key={keywords.keyword_id}
                                className={`${classes.Keyword} ${classes.truncate} clickable ${isGrayedOut ? classes.GrayedOut : ''}`}
                                onClick={() => {
                                }}
                            >
                                {keywords.keyword}
                            </div>
                        </OverlayTrigger>
                    ),
                    disableDrag: isGrayedOut,
                };
            });
            setFromList(updatedFromList);
        }
    }, [fromPattern, patternSelected, existsInToList]);

    useEffect(() => {
        if (toPattern && toPattern.keywords) {
            const updatedToList = toPattern.keywords.map((keywords) => {
                const id = keywords.keyword_id + " pattern_id-" + toPattern.pattern_id;
                return {
                    id,
                    keywordObj: keywords,
                    content: (
                        <OverlayTrigger
                            key={"overlay" + keywords.keyword_id}
                            trigger={['hover', 'focus']}
                            rootClose
                            //rootCloseEvent="hover-off"
                            placement='bottom'
                            overlay={<Popover id='pattern-keyword-description'>
                                <Popover.Title as="h3">{keywords.keyword}: Description</Popover.Title>
                                <Popover.Content className="keyword-description">
                                    {keywords.keyword_description}
                                </Popover.Content>
                            </Popover>}
                        >
                            <div
                                key={keywords.keyword_id}
                                className={`${classes.ToKeyWord} ${classes.truncate} clickable`}
                                onClick={() => {
                                }}
                            >
                                {keywords.keyword}
                            </div>
                        </OverlayTrigger>
                    ),
                    disableDrag: true
                };
            });
            setToList(updatedToList);
        }
    }, [toPattern, patternSelected]);

    const moveItemBetweenLists = (item, start, destination) => {
        if (start === destination) {
            return;
        }
        if (start === 'fromList' && destination === 'toList' && !existsInToList(item)) {
            let newItem = {...item}
            newItem.content = <div
                key={newItem.keywordObj.keyword_id}
                className={`${classes.Keyword} clickable ${styles.FromColor}`}
                onClick={() => {
                }}
            >
                {newItem.keywordObj.keyword}
            </div>


            setToList(prev => [newItem, ...prev]); // Add to target
        } else if (start === 'toList' && destination === 'fromList' && existsInFromList(item)) {
            setToList(prev => prev.filter(p => +p.keywordObj.keyword_id !== +item.keywordObj.keyword_id))
        }
    };

    useImperativeHandle(ref, () => ({
        getList: () => {
            return toList.map(item => item.keywordObj.keyword_id);  // Return the current state of toList
        }
    }));

    const moveAllValidItems = () => {
        fromList.forEach(item => moveItemBetweenLists(item, 'fromList', 'toList'))
    }

    return (
        <div className={styles.Container}>
            <div className={styles.SplitCols}>
                {/*<h3>Keywords:</h3>*/}
                {/*Comment above in and below out to disable*/}
                <h3>Keywords:</h3>
                <PulsingDivWrapper active={isDraggingFrom} additionalStyle={{width: '100%', height: '100%'}}>
                    <DroppableList
                        list={toList}
                        setList={setToList}
                        itemType={'KEYWORDS'}
                        targetListName="toList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        setDragging={setIsDraggingTo}
                        noStyle
                    />
                </PulsingDivWrapper>
            </div>
            <div className={styles.Separator}></div>
            <div className={styles.SplitCols}>
                <div className={styles.InlineTitleButtonContainer}>
                    <h3>Keywords:</h3>
                    <Button className={'preset-modal-button-button'} onClick={moveAllValidItems}>
                        <Forward style={{transform: 'rotate(180deg)', marginBottom: 2, alignSelf: 'center'}}/>
                        Add All
                    </Button>
                </div>
                <PulsingDivWrapper active={isDraggingTo} additionalStyle={{width: '100%', height: '100%'}}>
                    <DroppableList
                        list={fromList}
                        setList={setFromList}
                        itemType={'KEYWORDS'}
                        targetListName="fromList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        setDragging={setIsDraggingFrom}
                        noStyle
                    />
                </PulsingDivWrapper>
            </div>
        </div>
    )
});

export default KeywordsMergingDisplay;
